import { render, staticRenderFns } from "./subclassifiersTable.vue?vue&type=template&id=1ae42c94&scoped=true"
import script from "./subclassifiersTable.vue?vue&type=script&lang=js"
export * from "./subclassifiersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae42c94",
  null
  
)

export default component.exports